<!--
  Six columns plus a paginator do not fit a phone, so below 1024px the same
  rows are rendered as stacked cards instead of a table.
-->
@if (isCompact()) {
  <div class="booking-cards">
    @for (element of dataSource.data; track element.id) {
      <bad-booking-card
        [booking]="element"
        (click)="clickRowHandler(element)"
        (keydown.enter)="clickRowHandler(element)"
        (keydown.space)="onCardSpace($event, element)"></bad-booking-card>
    }
  </div>
} @else {
  <div class="rds-table-container">
    <table
      rds-table
      [dataSource]="dataSource"
      rdsSort
      (rdsSortChange)="onSortChange($event)"
      [rdsSortActive]="paginationState.sortBy"
      [rdsSortDirection]="paginationState.sortDirection">
      <ng-container rdsColumnDef="id">
        <th rds-header-cell *rdsHeaderCellDef rds-sort-header>ID</th>
        <td rds-cell *rdsCellDef="let element">{{ element.id }}</td>
      </ng-container>

      <ng-container rdsColumnDef="roomDescription">
        <th rds-header-cell *rdsHeaderCellDef>Description</th>
        <td rds-cell *rdsCellDef="let element">
          <p class="ui-body-m-bold">{{ element.eventName }}</p>
          <p>{{ element.roomDescription }}</p>
        </td>
      </ng-container>

      <ng-container rdsColumnDef="status">
        <th rds-header-cell *rdsHeaderCellDef>Status</th>
        <td rds-cell *rdsCellDef="let element">
          <rds-badge
            size="m"
            type="minimal"
            [color]="element.status.color"
            [label]="element.status.text"></rds-badge>
        </td>
      </ng-container>

      <ng-container rdsColumnDef="startTime">
        <th rds-header-cell *rdsHeaderCellDef rds-sort-header>Date & Time</th>
        <td rds-cell *rdsCellDef="let element">
          <p>{{ element.startDate | eventDateTime: element.endDate }}</p>
        </td>
      </ng-container>

      <ng-container rdsColumnDef="requester">
        <th rds-header-cell *rdsHeaderCellDef>Requester</th>
        <td rds-cell *rdsCellDef="let element">
          @let onBehalfParticipants = element?.onBehalfParticipants ?? [];
          <p class="requester">
            {{ element.requester.fullName
            }}{{ onBehalfParticipants.length > 0 ? ',' : '' }}
          </p>
          @for (
            onBehalf of onBehalfParticipants;
            track onBehalf.email;
            let last = $last
          ) {
            <p class="requester">
              {{ onBehalf.fullName }}{{ last ? '' : ',' }}
            </p>
          }
        </td>
      </ng-container>

      <ng-container rdsColumnDef="createTime">
        <th rds-header-cell *rdsHeaderCellDef>Created</th>
        <td rds-cell *rdsCellDef="let element">
          <p>{{ element.createTime | date: 'd.MM.yy, HH:mm' }}</p>
        </td>
      </ng-container>

      <ng-container rdsColumnDef="services">
        <th rds-header-cell *rdsHeaderCellDef>Service Provider</th>
        <td rds-cell *rdsCellDef="let element">
          @if (element.servicesBadge.length > 0) {
            <div class="badge-container">
              @for (service of element.servicesBadge; track $index) {
                @if (service.url && service.value === 'FURNITURE') {
                  <a
                    [href]="service.url"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="$event.stopPropagation()">
                    <rds-badge
                      size="m"
                      type="minimal"
                      [color]="service.color"
                      [label]="service.text"></rds-badge>
                  </a>
                } @else {
                  <rds-badge
                    size="m"
                    type="minimal"
                    [color]="service.color"
                    [label]="service.text"></rds-badge>
                }
              }
            </div>
          }
        </td>
      </ng-container>

      <tr rds-header-row *rdsHeaderRowDef="displayedColumns"></tr>
      <tr
        rds-row
        *rdsRowDef="let row; columns: displayedColumns"
        (click)="clickRowHandler(row)"></tr>
    </table>
  </div>
}
<rds-paginator
  [length]="paginationState.length"
  [pageIndex]="paginationState.pageIndex"
  [pageSize]="paginationState.pageSize"
  [pageSizeOptions]="[10, 20, 50]"
  [hidePageSize]="isCompact()"
  [showFirstLastButtons]="!isCompact()"
  (page)="onPageChange($event)"></rds-paginator>
